


// =========================
// TRAVEL FAQS
// =========================

import international from "./Travel/international";
import domestic from "./Travel/domestic";
import visa from "./Travel/visa";
import honeymoon from "./Travel/honeymoon";
import groupTravel from "./Travel/groupTravel";
import corporateTravel from "./Travel/corporateTravel";
import adventureTravel from "./Travel/adventureTravel";
import luxuryTravel from "./Travel/luxuryTravel";


// =========================
// EVENT FAQS
// =========================

import execution from "./Event/execution";
import budget from "./Event/budget";
import risk from "./Event/risk";
import logistics from "./Event/logistics";
import branding from "./Event/branding";
import planning from "./Event/planning";
import reporting from "./Event/reporting";
import weddingEvents from "./Event/weddingEvents";
import corporateEvents from "./Event/corporateEvents";
// import exhibitions from "./Event/exhibitions";
import artistManagement from "./Event/artistManagement";
// import venueManagement from "./Event/venueManagement";
import production from "./Event/production";
import hospitality from "./Event/hospitality";

const faqCategories = {
  travel: [
    international,
    domestic,
    visa,
    honeymoon,
    groupTravel,
    corporateTravel,
    adventureTravel,
    luxuryTravel,
  ],

  event: [
    execution,
    budget,
    risk,
    logistics,
    branding,
    planning,
    reporting,
    weddingEvents,
    corporateEvents,
    // exhibitions,
    artistManagement,
    // venueManagement,
    production,
    hospitality,
  ],
};

export default faqCategories;